import Analytics from 'src/lib/analytics';
const analytics = Analytics.event.builder().setPage('EP_NoteViewer');
export default analytics;
